import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

function AdminProtectedRoute({ children }) {
  const location = useLocation();
  const [isValidToken, setIsValidToken] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      // Make a request to the back end to validate the token
      axios.get('https://orca-app-mna7u.ondigitalocean.app/admin/validate_token', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        // If the token is valid, update the state
        setIsValidToken(response.status === 200);
        setIsLoading(false);
      })
      .catch(error => {
        // If there was an error (like a 401 response), the token is invalid
        setIsValidToken(false);
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return null; // Or a loading spinner, etc.
  } else {
    return isValidToken ? children : <Navigate to="/AdminLogin" state={{ from: location }} />;
  }
}

export default AdminProtectedRoute;
